import BaseBoosterBehavior from './BoosterBehavior/BaseBoosterBehavior';
import JokerBoosterBehavior from './BoosterBehavior/JokerBoosterBehavior';
import UndoBoosterBehavior from './BoosterBehavior/UndoBoosterBehavior';
import TNTBoosterBehavior from './BoosterBehavior/TNTBoosterBehavior';
import ShuffleBoosterBehavior from './BoosterBehavior/ShuffleBoosterBehavior';
import BullsEyeBoosterBehavior from './BoosterBehavior/BullsEyeBoosterBehavior';
import PlusFiveBoosterBehavior from './BoosterBehavior/PlusFiveBoosterBehavior';
import PlusThreeBoosterBehavior from './BoosterBehavior/HelperFriendPlusThreeBehavior';

export enum BoosterType {
    JOKER = 'joker',
    UNDO = 'undo',
    TNT = 'tnt',
    SHUFFLE = 'shuffle',
    BULLS_EYE = 'bullsEye',
    PLUS_FIVE = 'plusFive',
    HF_PLUS_THREE = 'hf_plusThree',
}

type tBoosterType = {
    [boosterType in BoosterType]: {
        //prototype: typeof GameObject;
        //handler: typeof BaseCardHandler;
        behavior: typeof BaseBoosterBehavior;
    };
};

export const BoosterTypeMap: tBoosterType = {
    [BoosterType.JOKER]: {
        //prototype: ValueCard,
        //handler: ValueCardHandler,
        behavior: JokerBoosterBehavior,
    },
    [BoosterType.UNDO]: {
        behavior: UndoBoosterBehavior,
    },
    [BoosterType.TNT]: {
        behavior: TNTBoosterBehavior,
    },
    [BoosterType.SHUFFLE]: {
        behavior: ShuffleBoosterBehavior,
    },
    [BoosterType.BULLS_EYE]: {
        behavior: BullsEyeBoosterBehavior,
    },
    [BoosterType.PLUS_FIVE]: {
        behavior: PlusFiveBoosterBehavior,
    },
    [BoosterType.HF_PLUS_THREE]: {
        behavior: PlusThreeBoosterBehavior,
    },
};
